///Move Nav Bar with page and shrink it
// function shrinkMobileNav(){
//   var mainNav = $('nav.main-navigation');
//   var logo = $('div.header__logo-wrapper');
  
//   // Get the initial height of the main navigation element
//   var initialHeight = mainNav.outerHeight();

//   // Attach a scroll event listener to the window object
//   $(window).scroll(function() {
//     // Get the current scroll position
//     var scrollPosition = $(window).scrollTop();
    
//     // Check if the scroll position is below the initial position of the main navigation
//     if (scrollPosition > (initialHeight*2)) {
//       // Set the height of the main navigation to half of its initial height
//       mainNav.css('height', initialHeight/1.5 + 'px');
//       logo.css('padding','0.5em');
//     } else {
//       // Set the height of the main navigation to its initial height
//       mainNav.css('height', initialHeight + 'px');
//       logo.css('padding','');
//     }
//   });
// }
import $ from 'jquery'; 

function shrinkMobileNav(){
  $(document).ready(function() {
    var lastScrollTop = 0;
    var lowestScroll = 0;
    var tolerance = 20;
    var mainNav = $('nav.main-navigation');
    
    // Get the initial height of the main navigation element
    var initialHeight = mainNav.outerHeight();

    // Attach a scroll event listener to the window object
    $(window).scroll(function() {
      var currentScrollTop = $(this).scrollTop();
      if (currentScrollTop > lastScrollTop && currentScrollTop > (initialHeight/2) ) {
        // User is scrolling down
        $('#masthead').css('translate','0 -'+initialHeight+'px');
        $('.nav-item__sub-nav').removeClass('nav-item__sub-nav--active')
      } else if(currentScrollTop > (lowestScroll + tolerance) || currentScrollTop == 0) {
        // User is scrolling up
        $('#masthead').css('translate','');
      }

      lastScrollTop = currentScrollTop;
      lowestScroll = (currentScrollTop < lowestScroll) ? currentScrollTop : lowestScroll; 
    });
  });
}
//shrinkMobileNav();


// //Search Bar Focus - Fade out nav
$('#site-navigation form[role=search]').on('focusin', function(){
    var navItems = $('.header__bottom-navigation .nav-item').get().reverse();
    $(navItems).each(function(index) {
      $(this).delay(100*index).queue(function(){
        $(this).addClass('make-room').dequeue();
      });
    });
  });
  $('#site-navigation form[role=search]').on('focusout', function(){
    $('.header__bottom-navigation .nav-item').each(function(index) {
      $(this).delay(100*index).queue(function(){
        $(this).removeClass('make-room').dequeue();
      });
    });
  });


//Cheap loading screen
//
setTimeout(function(){
  $('body').css('opacity','1');
 // console.log('showbody');
},500);

//Mobile nav click event
//
$('.header__burger-navigation').on('click',function(){
    $(this).toggleClass('make-criss-cross-applesauce');
    $('#mobile-menu').toggleClass('mobile-nav__takeover--active');
    $('#site-navigation .header__logo-wrapper').toggleClass('hide');
    $('#masthead').toggleClass('mobile-nav');
    $('#page').toggleClass('mobile-move');
    //prevents scrolling
    $('body').toggleClass('prevent-scrolling');
});

//Dropdown for subnav items (desktop)
//
$('.header__bottom-navigation .nav-item').hover(function(){
       // mouse in
       //remove old any active
       $('.header__bottom-navigation .nav-item__sub-nav--active').each(function () {
            $(this).removeClass('nav-item__sub-nav--active');
       });
        $(this).find('.nav-item__sub-nav').addClass('nav-item__sub-nav--active');
        $('.nav-item--has_sub').each(function() {
          var parentWidth = $(this).outerWidth();
          $(this).find('.nav-item__sub-nav').css('width', parentWidth + 'px');
        });
    },function(){
        //console.log($('div:hover')[0]);
        setTimeout(()=>{
          if ($('.header__bottom-navigation .nav-item__sub-nav--active:hover').length != 0) {
              //do nothing
          } else {
              $(this).find('.nav-item__sub-nav').removeClass('nav-item__sub-nav--active');
          }
        },250)
    });

//Dropdown for subnav items (mobile)
$('.nav-item--has_sub').on('click', 'i', function(e){
    $(this).next().toggleClass('nav-item__sub-nav--active');
})